export const getWindow = () => window;
export const getNavigator = () => navigator;

/**
 * Get the URL params from the current window location
 */

export function getWindowUrlParams() {
  const href = window.location.href;
  const startParamIdx = href.indexOf('?');
  if (startParamIdx === -1) {
    return null;
  }
  const searchParams = new URLSearchParams(href.substring(startParamIdx));
  return searchParams;
}

/**
 * Check if the user is being navigated to the URL from the Escrow webapp (Angular)
 */
export function checkFromWebapp() {
  const urlParams = getWindowUrlParams();
  return urlParams ? urlParams.get('w') === 'f' : false;
}
